import { Loader } from 'ui';
import { Img } from 'react-image';
import Lottie from 'react-lottie-player';
import { useToast } from 'src/context/ToastProvider';
import { IoShareSocialSharp } from 'react-icons/io5';
import { createApplicationV2 } from 'src/apis/application';
import { Avatar, Button, Tooltip } from 'flowbite-react';
import { useCallback, useEffect, useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import ValidityLine from 'src/components/shared/ValidityLine';
import { generateCompanyLogoAvatarSrc } from 'src/utils/companyLogo';
import arrowAnimation from '../../shared//animationFiles/arrowAnimation.json';
import { PositionStatus, PositionTitle, UIPosition, UIUser, UIUserRecommendation } from 'types';
import { FaLock } from 'react-icons/fa6';
import { useUserContext } from 'src/context/UserProvider';
import { ScheduleInterviewDrawer } from 'src/components/scheduleMeetingDrawer';
import { allowAllUsers, isRecruiterSide } from 'src/config/env.config';
import { generatePositionTitle, isUserAllowedToApply } from 'shared-utils';
import { get } from 'lodash';
import { sendTrackingEvent } from 'src/utils/gtm';
import { useLocation } from 'react-router-dom';
import useDisclosure from 'src/hooks/utils/useDisclosure';
import ShareablePositionModal from './ShareablePositionModal';
import LinkedInResumeModal from 'src/components/my-applications/LinkedInResumeModal';

interface Props {
	positionDetail: UIPosition;
	isFooter: boolean;
	userDetail: UIUser;
	isUserAlreadyApplied: boolean | null;
	numberOfSkillsBelowThreshold: number;
	closeDrawer: () => void;
	setIsPositionDrawerOpen: (val: boolean) => void;
	shouldBeUnlocked?: boolean;
	positionRecommendations?: UIUserRecommendation[];
	subTextForReason?: string;
}

const PositionDrawerHeaderFooter = ({
	positionDetail,
	numberOfSkillsBelowThreshold,
	userDetail,
	isFooter,
	closeDrawer,
	isUserAlreadyApplied,
	setIsPositionDrawerOpen,
	shouldBeUnlocked,
	positionRecommendations,
	subTextForReason,
}: Props) => {
	const location = useLocation();
	const { userMeetings, user, isScreeningRoundInCompleted } = useUserContext();
	const showLottie = !isFooter;
	const showCompanyAvatar = !isFooter;
	const queryClient = useQueryClient();
	const toast = useToast();
	const [isUnlocked, setIsUnlocked] = useState<boolean>();
	const [avatarImg, setAvatarImg] = useState<string>('');
	const { isOpen, onOpen, onClose } = useDisclosure();
	const [isScheduleInterviewDrawerOpen, setIsScheduleInterviewDrawerOpen] = useState<boolean>(false);
	const {
		isOpen: isLinkedInResumeModalOpen,
		onOpen: onLinkedInResumeModalOpen,
		onClose: onCloseLinkedInResumeModalOpen,
	} = useDisclosure();

	// only return true if user has not completed screening round and is not a masai student
	const shouldDisableInterviewBooking = user?.flags.isMasaiStudent ? false : !!isScreeningRoundInCompleted;

	const generateAvatar = useCallback(async () => {
		const res = await generateCompanyLogoAvatarSrc(positionDetail?.company?.logo || '', positionDetail?.company?.url);
		setAvatarImg(res);
	}, [positionDetail?.company?.logo, positionDetail?.company?.url]);

	const createApplicationMutation = useMutation(['createApplication'], createApplicationV2, {
		onSuccess() {
			queryClient.refetchQueries(['getPositions']);
			queryClient.refetchQueries(['getPositionById']);
			queryClient.refetchQueries(['GetApplicationsCount']);
			toast({
				title: 'Succesfully applied!',
				type: 'success',
			});
			closeDrawer();
			onCloseLinkedInResumeModalOpen();
		},
		onError(error: Error) {
			const errorMessage = get(error, ['response', 'data', 'message'], error.message);
			toast({
				title: errorMessage,
				type: 'error',
			});
			closeDrawer();
			onCloseLinkedInResumeModalOpen();
		},
	});

	useEffect(() => {
		generateAvatar();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [positionDetail?.company?.logo, positionDetail?.company?.url]);

	// Checking that wheather the user is eligible for job or not.
	useEffect(() => {
		// if (
		// 	typeof userDetail?.evaluation?.level === 'number' &&
		// 	typeof positionDetail?.positionRequirement.levelThreshold === 'number' &&
		// 	userDetail?.evaluation?.level >= positionDetail?.positionRequirement.levelThreshold
		// ) {
		// 	const checkSkillCredibility = positionDetail.positionRequirement.skillThresholds
		// 		?.filter(pst => pst.threshold)
		// 		.reduce((acc, pst) => {
		// 			const userSkillRating = userDetail.evaluation?.skillRatings?.find(usR =>
		// 				pst.skills.map(s => String(s._id)).includes(String(usR.skill)),
		// 			);
		// 			if (!userSkillRating) acc = false;
		// 			else if (Number(userSkillRating.rating) < Number(pst.threshold)) acc = false;
		// 			return acc;
		// 		}, true);
		// 	if (checkSkillCredibility) {
		// 		setIsUnlocked(true);
		// 	} else {
		// 		setIsUnlocked(false);
		// 	}
		// 	if (isUserAlreadyApplied) {
		// 		setIsUnlocked(false);
		// 	}
		// } else {
		// 	setIsUnlocked(false);
		// }
		// if(shouldBeUnlocked) setIsUnlocked(shouldBeUnlocked)

		positionRecommendations?.find(recommendation => {
			console.log('started:');
			if (recommendation?.user?._id === userDetail._id) console.log('recommendation:', recommendation);
			return recommendation?.user?._id === userDetail._id && recommendation?.isEligible;
		});
		if (isUserAlreadyApplied) {
			setIsUnlocked(false);
		} else if (
			positionRecommendations?.find(
				recommendation => recommendation?.user?._id === userDetail._id && recommendation?.isEligible,
			)
		) {
			setIsUnlocked(true);
		} else if (shouldBeUnlocked) {
			setIsUnlocked(true);
		} else {
			setIsUnlocked(false);
		}

		if (allowAllUsers && !isUserAlreadyApplied) {
			setIsUnlocked(true);
		} else if (isUserAlreadyApplied) {
			setIsUnlocked(false);
		}
		// if user is placed then user can't apply for the job
		if (
			!isUserAllowedToApply({
				isUserPlaced: !!userDetail?.flags?.isPlaced,
			})
		) {
			setIsUnlocked(false);
		}
	}, [
		shouldBeUnlocked,
		positionRecommendations,
		userDetail?.evaluation?.level,
		isUserAlreadyApplied,
		positionDetail.positionRequirement?.levelThreshold,
		userDetail,
		positionDetail.positionRequirement.skillThresholds,
		positionDetail._id,
		userDetail?.flags?.isPlaced,
	]);

	const proceedToApply = () => {
		if (
			// (typeof userDetail.evaluation?.level === 'number' &&
			// 	userDetail.evaluation?.level >= positionDetail.positionRequirement.levelThreshold) ||
			// shouldBeUnlocked
			isUnlocked
		) {
			createApplicationMutation.mutate({
				createInfo: {
					position: positionDetail._id.toString() || '',
					user: String(userDetail?._id) || '',
				},
			});
		}
	};

	// Function for creating new Application when click on Apply Button.
	const onApply = () => {
		if (
			// (typeof userDetail.evaluation?.level === 'number' &&
			// 	userDetail.evaluation?.level >= positionDetail.positionRequirement.levelThreshold) ||
			// shouldBeUnlocked
			isUnlocked
		) {
			if (!userDetail?.profile?.linkedInProfile) onLinkedInResumeModalOpen();
			else if (!userDetail?.profile?.resumeLink) onLinkedInResumeModalOpen();
			else proceedToApply();
		}
	};

	const positionTitle = generatePositionTitle(positionDetail.title as PositionTitle);

	return (
		<>
			<div className="flex justify-center text-[#28293D] dark:text-white px-4 py-[10px]">
				<div className="flex w-full justify-between">
					{showCompanyAvatar ? (
						<div className="flex gap-4">
							<div>
								<Avatar
									className="drawer-avatar-container"
									size={'md'}
									alt="companyLogo"
									img={avatarImg}
									rounded={true}
									bordered
								/>
							</div>
							<div>
								<div className="text-xl font-bold flex gap-3 items-center">
									{positionTitle.length > 20 ? (
										<Tooltip content={positionTitle} placement="top">
											{positionTitle.substring(0, 17)}...
										</Tooltip>
									) : (
										<>{positionTitle}</>
									)}
									<IoShareSocialSharp
										size={18}
										className="cursor-pointer text-[#6698FA] hover:text-[#4b6fb6] md:hidden"
										onClick={() => {
											onOpen();
										}}
									/>
								</div>
								<div
									onClick={() => window.open(`${positionDetail.company.url}`, '_blank')}
									className="flex cursor-pointer items-center gap-2 text-base font-medium text-[#6698FA] dark:text-inherit"
								>
									<span className="hover:underline">
										{positionDetail.company.name.length > 20 ? (
											<Tooltip content={positionDetail.company.name} placement="top">
												{positionDetail.company.name.length > 20
													? `${positionDetail.company.name.substring(0, 19)} ...`
													: `${positionDetail.company.name}`}
											</Tooltip>
										) : (
											<>
												{positionDetail.company.name.length > 20
													? `${positionDetail.company.name.substring(0, 19)} ...`
													: `${positionDetail.company.name}`}
											</>
										)}
									</span>
									<span>
										<Img
											loading="lazy"
											className=""
											src="/assets/externalLinkIcon.svg"
											alt="externalLinkIcon"
											width="16"
											height="16"
										/>
									</span>
								</div>
								<ValidityLine
									isPositionClosed={positionDetail?.positionStatus === PositionStatus.CLOSED}
									hasExpiryDate={positionDetail?.expiresAt ? true : false}
									postedOn={positionDetail.createdAt}
									expiresOn={positionDetail.expiresAt}
									updatedAt={positionDetail.updatedAt}
									smallText={true}
								/>
								{positionDetail?.hasBond ? (
									<div className="mt-2 bg-[#FFF8E5] rounded-[6px] px-2 py-1 hidden md:block max-h-[25px] max-w-max text-[#E57A00] dark:text-[#FACA15] text-xs font-[500] font-inter dark:bg-[#374151] dark:border dark:border-[#FACA15]">
										*This job includes bond agreement.
									</div>
								) : null}
							</div>
						</div>
					) : null}

					{isRecruiterSide ? (
						<div
							className={`${isFooter ? 'grow justify-between' : 'sm:hidden'
								} flex items-center sm:w-full sm:justify-between`}
						>
							<>
								<div>
									Hiring candidates at
									<span className="text-[#39D98A]">{' Level '}</span>
									<span>
										<Img
											className="mb-1 inline-block"
											src="/assets/lightning-bolt.png"
											alt="lightningBolt"
											width={16}
											height={16}
										/>{' '}
									</span>
									{Math.floor(positionDetail.positionRequirement.levelThreshold ?? 0)}+
								</div>
							</>
						</div>
					) : (
						<div
							className={`${isFooter ? 'grow justify-between' : 'sm:hidden'
								} flex items-center sm:w-full sm:justify-between`}
						>
							{showLottie ? <Lottie loop animationData={arrowAnimation} play={true} className="w-[73px] mr-3" /> : null}

							{positionDetail.positionStatus === PositionStatus.CLOSED ? (
								<>
									{isUserAlreadyApplied ? (
										<div className={`${showLottie ? 'ml-3 sm:ml-0 mr-4' : 'ml-0'}`}>
											<div className="text-base font-medium">{`🎉 Congratulations on applying.`}</div>
											<div className="mt-[4px] text-xs font-normal text-[#00B7C4] dark:text-[#73DFE7]">
												Stay tuned for updates on the next steps.
											</div>
										</div>
									) : (
										<div className={`${showLottie ? 'ml-3 sm:ml-0 mr-4' : 'ml-0'}`}>
											<div className="text-[16px]">
												<span className="dark:text-white">{`Hired `}</span>
												<span className="text-[#5B8DEF]">{positionDetail.hired ? positionDetail.hired : ''}</span>
												<span className="dark:text-white">{' aspirants at '}</span>
												<span className="font-[500] text-[#06C270] dark:text-[#39D98A]">{'Level '}</span>
												<span>
													<Img
														className="inline-block items-center"
														src="/assets/lightning-bolt.png"
														alt="lightningBolt"
														width={11}
														height={14}
													/>{' '}
												</span>
												<span className="dark:text-white">{`${Math.floor(
													positionDetail.positionRequirement.levelThreshold ?? 0,
												)}`}</span>
											</div>
											<div className="mt-[4px] text-xs font-normal text-[#00B7C4] dark:text-[#73DFE7]">
												Stay connected with us for future job opportunities.
											</div>
										</div>
									)}
								</>
							) : (
								<>
									{isUnlocked ? (
										<div
											className={`${showLottie ? 'ml-3 sm:ml-0 mr-4' : 'ml-0'} text-base font-medium`}
										>{`🎉 Hurray! You're eligible to apply.`}</div>
									) : isUserAlreadyApplied ? (
										<>
											<div className={`${showLottie ? 'ml-3 sm:ml-0 mr-4' : 'ml-0'}`}>
												<div className="text-base font-medium">{`🎉 Congratulations on applying.`}</div>
												<div className="mt-[4px] text-xs font-normal text-[#00B7C4] dark:text-[#73DFE7]">
													Stay tuned for updates on the next steps.
												</div>
											</div>
										</>
									) : (
										<div className={`${showLottie ? 'ml-3 sm:ml-0 mr-4' : 'ml-0'} text-base font-medium`}>
											<>
												<div className="">Company requirement mismatch</div>
												<div className="mt-[4px] text-xs font-normal dark:text-[#73DFE7]">
													{subTextForReason || 'You are not eligible for this position'}
												</div>
											</>
										</div>
									)}
								</>
							)}

							{positionDetail.positionStatus === PositionStatus.CLOSED ? (
								<>
									{isUserAlreadyApplied ? (
										<div className="ml-[26px] sm:ml-0">
											<Button color="purplePlaced" style={{ backgroundColor: '#05A660' }} size={'md'} disabled>
												Applied
											</Button>
										</div>
									) : (
										<div className="ml-[26px] sm:ml-0">
											<Button color="purplePlaced" size={'md'} disabled>
												Expired
											</Button>
										</div>
									)}
								</>
							) : (
								<>
									{isUserAlreadyApplied ? (
										<div className="ml-[26px] sm:ml-0">
											<Button color="purplePlaced" style={{ backgroundColor: '#05A660' }} size={'md'} disabled>
												Applied
											</Button>
										</div>
									) : isUnlocked ? (
										<div className="ml-[26px] sm:ml-0">
											<Button
												color="purplePlaced"
												size="md"
												onClick={onApply}
												disabled={createApplicationMutation.isLoading}
											>
												{createApplicationMutation.isLoading ? <Loader /> : `Apply`}
											</Button>
										</div>
									) : (
										<>
											{userMeetings.length === 0 ? (
												<div className="ml-[26px] sm:ml-0">
													<Button
														color="purplePlaced"
														size={'md'}
														onClick={() => {
															sendTrackingEvent({
																event: 'jobs_drawer_kyl',
																eventLabel: location.pathname,
															});
															setIsPositionDrawerOpen(false);
															setIsScheduleInterviewDrawerOpen(true);
														}}
														disabled={shouldDisableInterviewBooking}
													>
														Know your level
													</Button>
												</div>
											) : (
												<div className="ml-[26px] sm:ml-0">
													<Button color="purplePlaced" size="md" disabled>
														<FaLock className="mr-2" />
														Apply
													</Button>
												</div>
											)}
										</>
									)}
									<div
										className="border hidden md:flex items-center justify-center p-2 cursor-pointer hover:text-blue-700 hover:border-blue-700 ml-4 rounded-[8px] border-[#6698FA] text-[#6698FA]"
										onClick={() => {
											onOpen();
										}}
									>
										<IoShareSocialSharp size={20} />
									</div>
								</>
							)}
						</div>
					)}
				</div>
			</div>
			<ScheduleInterviewDrawer
				isOpen={isScheduleInterviewDrawerOpen}
				onClose={() => setIsScheduleInterviewDrawerOpen(false)}
			/>
			<ShareablePositionModal
				avatarImg={avatarImg}
				isOpen={isOpen}
				onClose={onClose}
				positionDetail={positionDetail as UIPosition}
			/>

			<LinkedInResumeModal
				isProfilePage={true}
				showLinkedInButton={!userDetail?.profile?.linkedInProfile}
				positionId={positionDetail?._id}
				isOpen={isLinkedInResumeModalOpen}
				onClose={() => {
					onCloseLinkedInResumeModalOpen();
				}}
				createApplicationLoading={createApplicationMutation?.isLoading}
				createApplicationMutation={createApplicationMutation}
			/>
		</>
	);
};

export default PositionDrawerHeaderFooter;
